import { computed, ref } from 'vue'

/**
 * useColFold · 纵向栏目折叠偏好（UI 强制规范）
 * ------------------------------------------------------------
 * 所有纵向侧栏一律可折叠，交互统一用 FoldTab 手柄（shared/FoldTab.vue）。
 * 折叠只收窄轨道为 0（面板 DOM 保留），偏好按 key 本机记忆（跨页共享同一存储）。
 */
type FoldMap = Record<string, boolean>
const FOLD_KEY = 'ema.col-folds.v1'

function readAll(): FoldMap {
  try { return JSON.parse(localStorage.getItem(FOLD_KEY) || '{}') || {} } catch { return {} }
}
const state = ref<FoldMap>(readAll())

export function useColFold(key: string) {
  const folded = computed({
    get: () => !!state.value[key],
    set: (v: boolean) => {
      state.value = { ...state.value, [key]: v }
      try { localStorage.setItem(FOLD_KEY, JSON.stringify(state.value)) } catch { /* 忽略 */ }
    },
  })
  const toggle = () => { folded.value = !folded.value }
  return { folded, toggle }
}
